import React, {useState,useEffect} from "react";
import axios from "axios"
//import EventType from "./EventType"
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Button } from "@mui/material";
import { useSnackbar } from 'notistack';


const MyOrders = (props) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    
    const fetchData = async () => {
      setIsLoading(true);
      try{

       //get orders from ReactJSOrder table specifically for user (where userid = "")
        const result = await axios(
            '/api/orders', 
        );
        setData(result.data);
        enqueueSnackbar('Orders fetch success');
      }
        catch(error){
        setError(true)
        enqueueSnackbar('Orders fetch failed');
      }
 
      
      setIsLoading(false);
      //console.log(data);
    };
 
    fetchData();
  }, []);


  const makePaymentNavigate = (event, cellValues) => {
    // Order-centric flow loads via OrderPayment (/api/orders/:id); attendee id is wrong here.
    navigate(`/makepayment/order/${cellValues.row["OrderID"]}`);
  };

  const columns = [
    {
      field: "Actions", width:275,
      renderCell: (cellValues) => {
        return (
          <div>
          <Button
            variant="contained"
            color="primary"
            onClick={(event) => {
              event.ignore = true;
              makePaymentNavigate(event, cellValues);
            }}
          >
            Make Payment
          </Button>
          </div>
        );
      }
    },
    { field: 'OrderID', headerName: 'ID', width:75 },
    { field: 'Balance', headerName: 'Balance', width:100},
    { field: 'PaidToDate', headerName: 'Amount Paid To Date', width:200},
    { field: 'Products', headerName:'Products', width:300,
      valueGetter: (cellValues) => {
        let productArr = [];
        if(Array.isArray(cellValues))
        {
          cellValues.map(function(product){
            productArr.push({
                product
            })
        })
      return productArr?.map((prod) => 
      {
        return prod?.ProductName;
          //let cat = categoriesList?.find(x=> x.CategoryID == catid);
          //return cat?.CategoryDisplayName;
      }
    
      ).join(" | ");
        }
        else{
          //handle cellvalues not array
          return "";
        }
        
      
    },
  },
  ];


  const gridStyle = {
    width: 1000,
  }
  
  return (
          <div>
            {error && (
              <div style={{ color: `red` }}>
                Error occurred while fetching api, Please contact an admin
              </div>
            )}
            {isLoading ? (
        <div>Loading ...</div>
          ) : (
            
            <div>
                <DataGrid flexGrow autoHeight={true} autoPageSize={true} pageSize={15} columns={columns} rows={data} getRowId={(row) => row.OrderID} 
                onRowClick={(params, event) => {
                  if (!event.ignore) {
                    navigate("/myorders/" + params.row.OrderID)
                  }
                }}
                components={{Toolbar: GridToolbar,}} 
                disableMultipleSelection={true} 
                disableSelectionOnClick={true} 
                /> 
            </div>
           
          )}
          </div>) 
}



export default MyOrders;


